import React, { Dispatch } from 'react';
import { IForumProps } from '../../models/pages/forum';
import { IAppState, IAction } from '../../models/action/core';
import { connect } from 'react-redux';
import CreateForum from '../../components/forum/createOrEditForum';
import CreateComment from '../../components/forum/createOrEditComment';
import ApplyWaitPost from '../../components/forum/applyWaitingPost';
import ForumProcess from '../../components/forum/forumProcess';
import ListForum from '../../components/forum/listForums';
import ForumPost from '../../components/forum/forumPost';
import { Log } from 'ng2-logger';
import { setForumThreadById } from '../../store/actions/forum';
import { Guid } from 'guid-typescript';

const _logger = Log.create('forum/main.tsx');

class ForumMain extends React.Component<IForumProps> {
    uppyInstance: any;

    state = {
        isCreateForumOpen: false,
        isCommentOpen: false,
        isApplyForumPostOpen: false,
        editForumThreadId: '',
        editForumMessageId: '',
        showFileUploaderAdd: false,
        showFileUploaderEdit: false,
    };

    public openCreateForumModal = () => {
        this.setState({ isCreateForumOpen: true, editForumThreadId: '' });
    };

    public closeCreateForumModal = () => {
        this.props.dispatch(
            setForumThreadById(
                { body: '', classIds: [], courseId: '', isCommon: true, subject: '', forumThreadId: '', isModerated: false },
                '',
                'set'
            )
        );
        this.setState({ isCreateForumOpen: false, editForumThreadId: '' });
    };

    public openEditForumModal = (forumThreadId: string) => {
        this.setState({ isCreateForumOpen: true, editForumThreadId: forumThreadId });
    };

    public openCreateCommentModal = (messageId: string) => {
        this.setState({ isCommentOpen: true, editForumMessageId: messageId });
    };

    public closeCreateCommentModal = () => {
        this.setState({ isCommentOpen: false });
    };

    public openApplyPostModal = () => {
        this.setState({ isApplyForumPostOpen: true });
    };

    public closeApplyPostModal = () => {
        this.setState({ isApplyForumPostOpen: false });
    };

    showFileUploader = (type: string) => {
        this.checkFileUploaderType(type);
    };

    checkFileUploaderType = (type: string) => {
        switch (type) {
            case 'Add':
                this.setState({
                    showFileUploaderAdd: !this.state.showFileUploaderAdd
                });
                break;
            case 'Edit':
                this.setState({
                    showFileUploaderEdit: !this.state.showFileUploaderEdit
                });
                break;
        }
    }

    resetFileUploader = () => {
        if (this.uppyInstance) {
            this.uppyInstance.reset();
        }
    };

    closeFileUploader = (uppy: any, type: string) => {
        this.checkFileUploaderType(type);
        this.uppyInstance = uppy;
    };

    fileUploadedHandler = (uppy: any, type: string) => {
        this.checkFileUploaderType(type);
        this.uppyInstance = uppy;
    };

    public render() {
        return (
            <div className="meesage-container col-container" style={{overflowX: "auto"}}>
                <ListForum openCreateForm={this.openCreateForumModal} classId={this.props.classId!} />
                <ForumPost
                    openCommentModal={this.openCreateCommentModal}
                    showFileUploader={this.showFileUploader}
                    showFileUploaderState={this.state.showFileUploaderAdd}
                    resetFileUploader={this.resetFileUploader}
                    closeFileUploader={this.closeFileUploader}
                    fileUploadedHandler={this.fileUploadedHandler}
                />
                <CreateForum
                    isOpen={this.state.isCreateForumOpen}
                    isClose={this.closeCreateForumModal}
                    forumThreadId={this.state.editForumThreadId}
                />
                <CreateComment
                    isOpen={this.state.isCommentOpen}
                    isClose={this.closeCreateCommentModal}
                    messageId={this.state.editForumMessageId}
                    showFileUploader={this.showFileUploader}
                    showFileUploaderState={this.state.showFileUploaderEdit}
                    resetFileUploader={this.resetFileUploader}
                    closeFileUploader={this.closeFileUploader}
                    fileUploadedHandler={this.fileUploadedHandler}
                />
                <ApplyWaitPost isOpen={this.state.isApplyForumPostOpen} isClose={this.closeApplyPostModal} />
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IForumProps) => {
    if (!state) {
        return ownProps;
    }
    const newProps: IForumProps = Object.assign({}, ownProps, {
        selectedForumThreadId: state.forum.forumMessageThreadId,
        identity: state.login.identitiy,
        moduleItems:state.login.login.moduleItems
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CForumMain = connect(
    mapStateToProps,
    dispatchProps
)(ForumMain);

export default CForumMain;
